import { useEffect } from 'react';

type SeoProps = {
  title: string;
  description: string;
  path: string;
  type?: 'website' | 'article';
  noIndex?: boolean;
};

type JsonLdProps = { data: Record<string, unknown> | Array<Record<string, unknown>> };

const siteUrl = 'https://ciftlikweb.com';

function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}

export default function Seo({ title, description, path, type = 'website', noIndex = false }: SeoProps) {
  useEffect(() => {
    const url = `${siteUrl}${path}`;
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', type);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    setMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');
  }, [description, noIndex, path, title, type]);

  return null;
}

export function SiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'CiftlikWeb',
        url: siteUrl,
        email: 'info@ciftlikweb.com',
        parentOrganization: { '@type': 'Organization', name: 'LoRoute' },
        contactPoint: { '@type': 'ContactPoint', contactType: 'sales', email: 'info@ciftlikweb.com', availableLanguage: 'Turkish' },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${siteUrl}/#software`,
        name: 'CiftlikWeb',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web, Android, iOS',
        inLanguage: 'tr-TR',
        description: 'Kurbanlık satış ve hisse takibi, dijital kesim sıramatiği, çiftlik cari ve müşteri takibi, canlı hayvan ile süt-et ve kanatlı işletme operasyonları için Türkçe bulut yazılımı.',
        url: siteUrl,
        provider: { '@id': `${siteUrl}/#organization` },
        offers: { '@type': 'Offer', priceCurrency: 'TRY', price: '7000', description: 'Aylık kullanım bedeli. Kurulum ve KDV koşulları için fiyatlandırma sayfasını inceleyin.' },
      },
    ],
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}

export function JsonLd({ data }: JsonLdProps) {
  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
}
